import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import { computed, nextTick, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import { Selector } from '@shell/types/fleet';
import LabeledSelect from '@shell/components/form/LabeledSelect.vue';
import MatchExpressions from '@shell/components/form/MatchExpressions.vue';
import { RcButton } from '@components/RcButton';

interface SelectOption {
  label: string,
  value: string,
  disabled?: boolean,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClusterSelectionFields',
  props: {
    selectedClusters: { default: () => [] },
    selectedClusterGroups: { default: () => [] },
    clusterSelectors: { default: () => [] },
    clustersOptions: { default: () => [] },
    clusterGroupsOptions: { default: () => [] },
    mode: {},
    isView: { type: Boolean, default: false },
    variant: { default: 'default' },
    compact: { type: Boolean, default: false }
  },
  emits: ["select-clusters", "select-cluster-groups", "add-match-expressions", "update-match-expressions", "remove-match-expressions"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

// eslint-disable-next-line func-call-spacing
const emit = __emit;

const store = useStore();
const { t } = useI18n(store);

const isAppco = computed(() => props.variant === 'appco');

const byLabelHeading = computed(() => {
  if (isAppco.value) {
    return 'h4';
  }

  return props.compact ? 'h5' : 'h4';
});

const groupHeading = computed(() => {
  if (isAppco.value) {
    return 'h4';
  }

  return props.compact ? 'h4' : 'h3';
});

const addButtonClass = computed(() => (isAppco.value ? 'mmt-3' : 'mmt-4'));

const matchExpressionRefs = ref<Record<number, any>>({});

function setMatchExpressionRef(key: number | undefined, el: any) {
  if (key === null || key === undefined) {
    return;
  }

  if (el) {
    matchExpressionRefs.value[key] = el;
  } else {
    delete matchExpressionRefs.value[key];
  }
}

function focusMatchExpression(key: number) {
  nextTick(() => {
    matchExpressionRefs.value[key]?.focus();
  });
}

__expose({ focusMatchExpression });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(isAppco.value ? 'appco-select-clusters' : undefined)
  }, [
    _createElementVNode("div", null, [
      (isAppco.value)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_unref(t)('fleet.clusterTargets.clusters.byName.title')), 1))
        : _createCommentVNode("", true),
      _cache[3] || (_cache[3] = _createTextVNode()),
      _createVNode(LabeledSelect, {
        "data-testid": "fleet-target-cluster-name-selector",
        class: _normalizeClass({ 'mmt-4': !isAppco.value && !__props.compact }),
        value: __props.selectedClusters,
        label: _unref(t)('fleet.clusterTargets.clusters.byName.label'),
        options: __props.clustersOptions,
        taggable: true,
        "close-on-select": false,
        mode: __props.mode,
        multiple: true,
        placeholder: _unref(t)('fleet.clusterTargets.clusters.byName.placeholder'),
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (emit('select-clusters', $event)))
      }, null, 8, ["class", "value", "label", "options", "mode", "placeholder"])
    ]),
    _cache[11] || (_cache[11] = _createTextVNode()),
    (!__props.isView || (__props.clusterSelectors && __props.clusterSelectors.length > 0))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({ 'mmt-6': !isAppco.value })
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(byLabelHeading.value), {
            class: _normalizeClass({ 'm-0': !isAppco.value })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('fleet.clusterTargets.clusters.byLabel.title')), 1)
            ]),
            _: 1
          }, 8, ["class"])),
          _cache[8] || (_cache[8] = _createTextVNode()),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.clusterSelectors, (selector, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: selector.key,
              class: "match-expressions-container mmt-4"
            }, [
              _createVNode(MatchExpressions, {
                ref_for: true,
                ref: (el) => setMatchExpressionRef(selector.key, el),
                class: "body",
                value: selector,
                mode: __props.mode,
                "initial-empty-row": true,
                "label-key": _unref(t)('fleet.clusterTargets.clusters.byLabel.labelKey'),
                "add-icon": 'icon-plus',
                "add-class": 'btn-sm',
                "onUpdate:value": ($event: any) => (emit('update-match-expressions', i, $event, selector.key))
              }, null, 8, ["value", "mode", "label-key", "onUpdate:value"]),
              _cache[5] || (_cache[5] = _createTextVNode()),
              (!__props.isView)
                ? (_openBlock(), _createBlock(_unref(RcButton), {
                    key: 0,
                    size: "small",
                    variant: "link",
                    "aria-label": _unref(t)('fleet.clusterTargets.clusters.byLabel.removeSelector'),
                    onClick: ($event: any) => (emit('remove-match-expressions', selector.key))
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("i", {
                        class: "icon icon-x",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]))]),
                    _: 1
                  }, 8, ["aria-label", "onClick"]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _cache[9] || (_cache[9] = _createTextVNode()),
          (!__props.isView)
            ? (_openBlock(), _createBlock(_unref(RcButton), {
                key: 0,
                size: "small",
                variant: "secondary",
                class: _normalizeClass(addButtonClass.value),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('add-match-expressions')))
              }, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "icon icon-plus" }, null, -1)),
                  _cache[7] || (_cache[7] = _createTextVNode()),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('fleet.clusterTargets.clusters.byLabel.addSelector')), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _cache[12] || (_cache[12] = _createTextVNode()),
    _createElementVNode("div", {
      class: _normalizeClass({ 'mmt-8': !isAppco.value })
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(groupHeading.value), {
        class: _normalizeClass({ 'm-0': !isAppco.value })
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('fleet.clusterTargets.clusterGroups.title')), 1)
        ]),
        _: 1
      }, 8, ["class"])),
      _cache[10] || (_cache[10] = _createTextVNode()),
      _createVNode(LabeledSelect, {
        "data-testid": "fleet-target-cluster-group-selector",
        class: _normalizeClass({ 'mmt-4': !isAppco.value }),
        value: __props.selectedClusterGroups,
        label: _unref(t)('fleet.clusterTargets.clusterGroups.byName.label'),
        options: __props.clusterGroupsOptions,
        taggable: true,
        "close-on-select": false,
        mode: __props.mode,
        multiple: true,
        placeholder: _unref(t)('fleet.clusterTargets.clusterGroups.byName.placeholder'),
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (emit('select-cluster-groups', $event)))
      }, null, 8, ["class", "value", "label", "options", "mode", "placeholder"])
    ], 2)
  ], 2))
}
}

})